import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

const TopButtons = () => {
  return (
    <div className="topButtons">
      <Breadcrumbs />
    </div>
  );
};

export default TopButtons;
